import { render, staticRenderFns } from "./WalletLastTransactions.vue?vue&type=template&id=2ec317da&"
import script from "./WalletLastTransactions.vue?vue&type=script&lang=js&"
export * from "./WalletLastTransactions.vue?vue&type=script&lang=js&"
import style0 from "./WalletLastTransactions.vue?vue&type=style&index=0&id=2ec317da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports